import { useTheme } from '@emotion/react';
import { Button, Dialog, Stack } from '@mui/material';
import React from 'react';
import { useRef } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import ModalHeader from '../ModalHeader';
import { Form, Formik } from 'formik';
import FormTextField from '../FormTextField';
import { useState } from 'react';
import * as yup from 'yup';
import { buttonStyle1 } from '../../utils/commonStyle';
import { showmessage } from '../../utils/toastr';
import { setLoading } from '../../redux/features/appSlice';
import { refreshUserData } from '../../redux/features/authSlice';
import appapi from '../../api/apiClient';
import { useTranslation } from 'react-i18next';

const validationSchema = yup.object({
  oldPassword: yup.string().required('Password is required'),
  // .matches(/^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*?&])[A-Za-z\d@$!%*?&]{8,20}$/, 'Enter a password of minimum 8 and maximum 20 characters with a combination of capital letters, small letters, symbols, and numbers.'),
  newPassword: yup
    .string()
    .required('Password is required')
    .matches(/^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*?&])[A-Za-z\d@$!%*?&]{8,20}$/, 'Enter a password of minimum 8 and maximum 20 characters with a combination of capital letters, small letters, symbols, and numbers.'),
  confirmPassword: yup
    .string()
    .oneOf([yup.ref('newPassword'), null], 'Passwords must match')
    .required()
    .trim(),
});

const sx = {
  '& .MuiDialog-container': {
    alignItems: 'center',
    WebkitAlignItems: 'center',
    WebkitBoxAlign: 'center',
  },
  '& .MuiPaper-root': {
    width: '528px',
    margin: '8px',
    borderRadius: '4px',
    maxWidth: '640px',
    maxHeight: 'calc(100% - 20px)',
    minHeight: '640px',
  },
};

export default function ChangePassword({ modelOpen, onModelHandleClose }) {
  const formRef = useRef();
  const theme = useTheme();
  const dispatch = useDispatch();
  const { t } = useTranslation();
  const text = theme.palette.primary.text;

  const { userId, user } = useSelector((state) => state.auth);

  const [visibility, setVisibility] = useState(false);
  const [visibility2, setVisibility2] = useState(false);
  const [visibility3, setVisibility3] = useState(false);

  const createPassword = async (obj) => {
    dispatch(setLoading(true));
    let payload = {
      userId,
      ...obj,
    };
    const response = await appapi.put(`user/createPassword`, payload);
    if (response.ok) {
      const data = response.data;
      if (data.status === '7400') {
        dispatch(refreshUserData({ ...user, resetPassword: false }));
        showmessage(data.message, 'success');
        onModelHandleClose(true);
      } else {
        showmessage(data.message, 'error');
      }
      dispatch(setLoading(false));
    } else {
      dispatch(setLoading(false));
      // showmessage(`Something Went Wrong!`, 2000, 'error')
    }
  };
  return (
    <Dialog
      sx={sx}
      open={modelOpen}
    >
      <Stack
        // className="!h-[100%]"
        flex={1}
        style={{ backgroundColor: '#FFFFFF' }}
      >
        <ModalHeader
          label={t('Change Password')}
          onClose={() => onModelHandleClose(false)}
        />
        <Stack
          style={{ backgroundColor: '#8993AC26', width: '100%', height: '2px' }}
          className=""
        />
        <Formik
          innerRef={formRef}
          enableReinitialize={true}
          initialValues={{
            oldPassword: '',
            newPassword: '',
            confirmPassword: '',
          }}
          validationSchema={validationSchema}
          onSubmit={(values) => createPassword(values)}
        >
          {({ handleSubmit, values, handleChange, errors, touched, handleBlur, isValid, dirty }) => (
            <Form
              noValidate
              autoComplete="off"
            >
              <Stack
                flex={1}
                className="mt-9 mx-[16px]"
              >
                <FormTextField
                  outlineLabel={t('Enter Old Password')}
                  name="oldPassword"
                  type="password"
                  sx={{ mb: '14px' }}
                  visibility={visibility}
                  setVisibility={(val) => setVisibility(val)}
                />
              </Stack>
              <Stack
                flex={1}
                className="mt-14 mx-[16px]"
              >
                <FormTextField
                  outlineLabel={t('Enter New Password')}
                  name="newPassword"
                  type="password"
                  sx={{ mb: '14px' }}
                  visibility={visibility2}
                  setVisibility={(val) => setVisibility2(val)}
                />
              </Stack>
              <Stack
                flex={1}
                className="mt-14 mx-[16px]"
              >
                <FormTextField
                  outlineLabel={t('Confirm New Password')}
                  name="confirmPassword"
                  type="password"
                  sx={{ mb: '14px' }}
                  visibility={visibility3}
                  setVisibility={(val) => setVisibility3(val)}
                />
              </Stack>
              <Stack flexGrow={1} />
              <Stack
                justifyContent="flex-end"
                className="px-[16px] pb-[16px] !mt-[280px]"
                style={{ alignSelf: 'flex-end' }} 
                direction={'row'}
              >
                <Button
                onClick={() => onModelHandleClose()}
                  sx={{
                    ...buttonStyle1,
                    width: '25%',
                    mt: '2.3px',
                    color: theme.palette.primary.main,
                   
                    '&:hover': {
                      // backgroundColor: theme.palette.primary.main,
                      // color: '#fff',
                    },
                    '&:disabled': {
                      color: 'rgba(255,255,255,0.5)',
                      backgroundColor: theme.palette.primary.main,
                    },
                  }}
                  type="submit"
                  style={{marginRight:"10px"}}
                >
                  {t('Close')}
                </Button>
                <Button
                  sx={{
                    ...buttonStyle1,
                    width: '25%',
                    mt: '2.3px',
                    color: '#fff',
                    backgroundColor: theme.palette.primary.main,
                    '&:hover': {
                      backgroundColor: theme.palette.primary.main,
                      color: '#fff',
                    },
                    '&:disabled': {
                      color: 'rgba(255,255,255,0.5)',
                      backgroundColor: theme.palette.primary.main,
                    },
                  }}
                  disabled={!(dirty && isValid)}
                  type="submit"
                >
                {t('Update')}
                </Button>
              </Stack>
            </Form>
          )}
        </Formik>
      </Stack>
    </Dialog>
  );
}
